import React from 'react';
import styled from 'styled-components';
import { Bell, Truck, Receipt, Euro, MapPin, Package } from 'lucide-react';
import { colors, spacing, borderRadius, fontSize, fontWeight, shadows } from '../../styles/theme';

const WidgetCard = styled.div`
  background-color: ${colors.white};
  padding: ${spacing.lg};
  border-radius: ${borderRadius.md};
  box-shadow: ${shadows.sm};
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 12px 40px rgba(234, 115, 23, 0.2);
  }
  
  @media (max-width: 768px) {
    padding: ${spacing.md};
  }
  
  @media (max-width: 480px) {
    padding: ${spacing.sm};
  }
`;

const WidgetNumber = styled.div`
  font-size: ${fontSize.xxl};
  font-weight: ${fontWeight.bold};
  color: ${props => props.color || colors.text};
  margin-bottom: ${spacing.xs};
`;

const WidgetLabel = styled.div`
  font-size: ${fontSize.sm};
  color: ${colors.muted};
`;

const iconMap = {
  Bell,
  Truck,
  Receipt,
  Euro,
  MapPin,
  Package,
};

export default function Widget({ widget, value, formatValue, labelOverride }) {
  const Icon = iconMap[widget.icon] || Bell;
  
  return (
    <WidgetCard>
      <Icon size={24} color={widget.color} style={{ marginBottom: spacing.xs }} />
      <WidgetNumber color={widget.color}>
        {formatValue ? formatValue(value) : value}
      </WidgetNumber>
      <WidgetLabel>{labelOverride || widget.name}</WidgetLabel>
    </WidgetCard>
  );
}


